import React from "react";
import {
  Link,
  Switch,
  Route,
  BrowserRouter
} from "react-router-dom";
import { Helmet } from "react-helmet";


import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Cases from "./components/cases";
import Information from "./components/information";
import Gallery from "./components/gallery";

import header from './images/mathemCase/header.png';
import overviewOld from './images/mathemCase/overviewOld.png';
import audit from './images/mathemCase/audit.png';
import toolbox from './images/mathemCase/toolbox.png';
import system from './images/mathemCase/system.png';
import exploration from './images/mathemCase/exploration.png';

import result1 from './images/mathemCase/result1.png';
import result2 from './images/mathemCase/result2.png';
import result3 from './images/mathemCase/result3.png';
import result4 from './images/mathemCase/result4.png';
import result5 from './images/mathemCase/result5.png';
import result6 from './images/mathemCase/result6.png';
import result7 from './images/mathemCase/result7.png';
import result8 from './images/mathemCase/result8.png';

function Navigation() {

  return (
    <div>
      <Information />

      <Row>
        <Col xs={12} md={6}>
          <Link to="/"><span class="material-icons">west</span></Link>
          <h1>Mathem</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <img src={header} alt="Girl in a jacket" width="100%" />
        </Col>
      </Row>

      <Row className="justify-content-md-center block-center">
      <Col className="text-block" xs={{span: 10, offset: 1}} md={10} lg={8} xl={6}>
          <h2>Goal of the project</h2>
          <p>Mathem has been delivering groceries to customers for 10+ years. Shopping groceries online has become the norm and with more competitors it's becoming important for Mathem to reinforce their user experience. The project had two goals. 1. Understand current problems with the user experience. 2. How do we incorporate the new Mathem brand. </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <img src={overviewOld} alt="Girl in a jacket" width="100%" />
        </Col>
      </Row>

      <Row className="block">
        <Col className="text-block" xs={{span: 10, offset: 1}} md={{span: 10, offset: 1}} lg={{span: 8, offset: 2}} xl={{span: 4, offset: 0}}>
          <h2>Auditing current features, patterns and components</h2>
          <p>In order the reach the goal and understand the scope of the project we started with auditing the current user experience. Using data and previous research we valued what features was important and what features had problems. After that we broke down the use of patterns and components and styles.</p>
        </Col>
        <Col md={{span: 12, offset: 0}} lg={{span: 12, offset: 0}} xl={{span: 7, offset: 1}}>
          <img src={audit} className="" alt="Girl in a jacket" width="100%" />
        </Col>
      </Row>

      <Row className="block">
        <Col className="text-block"  xs={{span: 10, offset: 1}} md={{span: 10, offset: 1}} lg={{span: 8, offset: 2}} xl={{span: 4, offset: 0}}>
          <h2>The new toolbox</h2>
          <p>The new brand for Mathem was created by Bold. The goal was to figure out how we can translate the new components of the brand to work with the digital plattforms. In short the new toolbox included a new logotype, typeface, color and illustrations.</p>
        </Col>
        <Col md={{span: 12, offset: 0}} lg={{span: 12, offset: 0}} xl={{span: 7, offset: 1}}>
          <img src={toolbox} className="" alt="Girl in a jacket" width="100%" />
        </Col>
      </Row>

      <Row className="block">
        <Col className="text-block" xs={{span: 10, offset: 1}} md={{span: 10, offset: 1}} lg={{span: 8, offset: 2}} xl={{span: 4, offset: 0}}>
          <h2>Setting up the foundation</h2>
          <p>One of the reasons for the current convoluted user experience is the lack of consistency in the use of visual styling and patterns. Before we conducted any exploring we created a core foundation that included styling and pattern use. This made it easier for us to test and change things. </p>
        </Col>
        <Col md={{span: 12, offset: 0}} lg={{span: 12, offset: 0}} xl={{span: 7, offset: 1}}>
          <img src={system} className="" alt="Girl in a jacket" width="100%" />
        </Col>
      </Row>

      <Row className="block">
        <Col className="text-block"  xs={{span: 10, offset: 1}} md={{span: 10, offset: 1}} lg={{span: 8, offset: 2}} xl={{span: 4, offset: 0}}>
          <h2>Exploring and testing different solutions</h2>
          <p>With a clearer picture of the current situation and with a core foundation to start with, the biggest phase of the project began. We hade a couple of goals that guided us: 1. Remove/Hide features that is not used or is not important for the business in order to make the flows less complex. 2. Shout less with colors and focus on what is important with less. 3. Simplify and create visual hierarchy in order to reduce cognitive load.</p>
        </Col>
        <Col md={{span: 12, offset: 0}} lg={{span: 12, offset: 0}} xl={{span: 7, offset: 1}}>
          <img src={exploration} className="" alt="Girl in a jacket" width="100%" />
        </Col>
      </Row>

      <Row className="justify-content-md-center block-center">
        <Col className="text-block" xs={{span: 10, offset: 1}} md={10} lg={8} xl={6}>
          <h1>The end results</h1>
          <p><a target="_blank" href = "https://apps.apple.com/se/app/mathem/id1076840480#?platform=iphone">Mathem iOS AppStore</a><span class="material-icons-small">east</span></p>

        </Col>
      </Row>

      <Row className="justify-content-md-center">
        <Col xs={12}md={6}>
          <img src={result1} className="" alt="Girl in a jacket" width="100%" />
        </Col>
        <Col xs={12}md={6}>
          <img src={result2} className="" alt="Girl in a jacket" width="100%" />
        </Col>
        <Col xs={12}md={6}>
          <img src={result3} className="" alt="Girl in a jacket" width="100%" />
        </Col>
        <Col xs={12}md={6}>
          <img src={result4} className="" alt="Girl in a jacket" width="100%" />
        </Col>
        <Col xs={12}md={12}>
          <img src={result5} className="" alt="Girl in a jacket" width="100%" />
        </Col>
        <Col xs={12}md={6}>
          <img src={result6} className="" alt="Girl in a jacket" width="100%" />
        </Col>
        <Col xs={12}md={6}>
          <img src={result7} className="" alt="Girl in a jacket" width="100%" />
        </Col>
        <Col xs={12}md={12}>
          <img src={result8} className="" alt="Girl in a jacket" width="100%" />
        </Col>
      </Row>
    </div>
  );
}

export default Navigation;
